<template>
    <div style="position: relative">
        <div class="descAlert" v-show="['zxsq_jm','zlbg_jm','dbsq_jm','zzts_jm','fjsq_jm','ysxz_jm'].indexOf(currentPage)==-1">
            <p v-for="(item,index) in DescList" :key="index">{{item.desc}}</p>
            <!--<a :href="DescLink" target="_blank" style="padding-left:5px;"> >点击此处查看详细介绍</a>-->
        </div>
        <div style="padding:20px 20%">
            <div style="margin-top:30px">
                <Divider style="color:#888;font-size:12px;">户主信息</Divider>
                <SelectRole @currentRoleData="CurrentRoleData" ref="RoleForm"></SelectRole>
            </div>

            <Divider style="color:#888;font-size:12px;">客户信息</Divider>

            <Form ref="FormValidate" :model="FormValidate" :rules="RuleValidate" :label-width="110">
                <FormItem label="客户编号" prop="S_CID"  v-if="currentPage!='yhfzxz_jm'">
                    <Select v-model="FormValidate.S_CID"
                            filterable allow-create
                            @on-select="ScidBlur"
                            :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''"
                            ref="SelectScidRef">
                        <Option v-for="item in ScidDataList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="户名"  prop="S_HM"  v-if="currentPage!='yhfzxz_jm'">
                    <Input v-model="FormValidate.S_HM" disabled="disabled" />
                </FormItem>
                <FormItem label="地址"  prop="S_DZ"  v-if="currentPage!='yhfzxz_jm'">
                    <Input v-model="FormValidate.S_DZ" disabled="disabled" />
                </FormItem>
                <FormItem label="用水性质"  prop="WaterNature" v-show="currentPage=='ysxz_jm'&&currentPage!='yhfzxz_jm'">
                    <Input v-model="FormValidate.WaterNature" disabled="disabled" />
                </FormItem>
                <FormItem label="水价"  prop="WaterPrice" v-show="currentPage=='ysxz_jm'&&currentPage!='yhfzxz_jm'">
                    <Input v-model="FormValidate.WaterPrice" disabled="disabled" />
                </FormItem>
                <FormItem label="欠费"  prop="WaterArrears" v-if="currentPage!='yhfzxz_jm'">
                    <Input v-model="FormValidate.WaterArrears" disabled="disabled" />
                </FormItem>
                <!--<FormItem label="手机号"  prop="PhoneNum" v-show="FormValidate.PhoneNumShow">-->
                <!--<Input v-model="FormValidate.PhoneNum" disabled="disabled" />-->
                <!--</FormItem>-->

                <div v-for="(item,index) in CurrentViewArr" :key="index">
                    <FormItem :label="item.value"  :prop="item.prop">
                        <Input v-model="FormValidate[item.prop]" v-if="item.type=='input'" type="text"
                               :disabled="FormValidate.BtnName=='提交'&&['zlbg_jm','dbsq_jm','zzts_jm', 'fjsq_jm','ysxz_jm'].indexOf(currentPage)==-1||
                               (currentPage=='yhfzxz_jm'&&FormValidate.SelectList.S_YongTu.CurrentKey!=4)&&item.prop=='S_YongTuSM'" />
                        <Input v-model="FormValidate[item.prop]" v-else-if="item.type=='textarea'" type="textarea" :autosize="true"
                               :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''
                            ||FormValidate.BtnName=='提交'&&['zlbg_jm','dbsq_jm','zzts_jm', 'fjsq_jm','ysxz_jm'].indexOf(currentPage)==-1" />
                        <Select v-model="FormValidate.SelectList[item.prop].CurrentKey"
                                v-else-if="item.type=='select'"
                                :disabled="FormValidate.BtnName=='提交'">
                            <Option v-for="(p,o) in FormValidate.SelectList[item.prop].List" :value="p.value" :key="o">{{ p.label }}</Option>
                        </Select>
                        <Cascader :data="FormValidate.Cascader.List"
                                  v-model="FormValidate.Cascader[item.prop]"
                                  v-else-if="item.type=='timeperiod'"
                                  style="width:100%"
                                  @on-visible-change="GetCascaderData"
                                  :render-format="label => label.join(' ')"
                                  :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''"></Cascader>
                        <RadioGroup v-model="SelectList[item.prop].CurrentKey" v-else-if="item.type=='radio'"  :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''" >
                            <Radio v-for="(k,i) in SelectList[item.prop].List"  :label="k.value" :key="i" :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''" ><span>{{ k.label }}</span></Radio>
                        </RadioGroup>
                        <div v-if="item.type=='inputVaild'">
                            <Input v-model="FormValidate[item.prop]"  type="text"  :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''"  />
                            <SendMsg class="sendMsg"  :fn="GetValidCode" :deftext="'获取验证码'" ref='btn' :second='60' :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''" ></SendMsg>
                        </div>

                        <Card v-else-if="item.type=='inputs'">
                            <div v-for="(k,i) in FormDynamic.items" :key="i">
                                <Form :ref="'FormDynamic' + i" :model="k" :rules="RuleValidate" inline :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''" >
                                    <FormItem prop="PersonName" style="padding:10px 0;">
                                        <Input type="text" v-model="k.PersonName" placeholder="请输入户主姓名"  style="min-width:120px;" :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''" />
                                    </FormItem>
                                    <FormItem prop="PersonID" style="padding:10px 0;">
                                        <Input type="text" v-model="k.PersonID" placeholder="请输入身份证号码"  style="min-width:150px;" :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''" />
                                    </FormItem>
                                    <FormItem  style="padding:10px 0;">
                                        <Button @click="HandleRemoveInfo(i)"  ghost type="error" :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''" >删除</Button>
                                    </FormItem>
                                </Form>
                            </div>
                            <Button ghost type="success" long @click="HandleAdd" icon="md-add" style="margin-top:20px;" :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''" >增加</Button>
                        </Card>
                        <div v-else-if="item.type=='file'">
                            <UploadImg :MaxSize="item.size"
                                       :MaxLength="item.maxLength"
                                       :Prop="item.prop"
                                       :Value="item.value"
                                       :FormatType="['jpg','jpeg','png']"
                                       :isValid="item.isValid"
                                       :ref="item.prop"
                                       @fatherImage="fatherImage"
                                       @loadingSpin="loadingSpin"
                                       :disabled="FormValidate.BtnName=='提交'&&XieYiWJList!=''"
                                       :ChangedList="FormValidate[item.prop]"
                                       :Type="item.Type"
                            ></UploadImg>
                            <div v-if="item.Type==1||item.Type==2">
                                <Button type="primary" 
                                style="width:160px;background-color: #E4F2FF!important;border-color: #E4F2FF!important;color:#0F71B3"
                                @click="Certification(item.Type)">获取{{item.value}}照</Button>
                            </div>
                        </div>
                    </FormItem>
                </div>

                <!--<p v-show="currentPage=='ghsq_jm'&&FormValidate.PopulationNum>4" style="margin:10px 0 10px 50px;">注：户口本、社区证明至少二选一，如果家庭成员不在户口本上，请上传社区证明</p>-->
                <!--<p v-show="currentPage=='jthd_jm'" style="margin:10px 0 10px 50px;">注：户口本、社区证明、暂住证至少三选一，如果家庭成员不在户口本上，请上传社区证明或暂住证</p>-->

                <!--生成申请单后要继续操作，下载和提交申请单-->
                <div v-if="FormValidate.BtnName=='提交'&&XieYiWJList!=''">
                    <div v-for="(item,index) in ButtonDownArr" :key="'item'+index">
                        <FormItem :label="'下载'+item.name">
                            <a :href='DomainApi+item.url' target="_blank">点此下载</a>
                        </FormItem>
                    </div>

                    <div v-for="(item_dzq,index_dzq) in DianZiQianArr" :key="'dzq'+index_dzq">
                        <FormItem :label="'签订'+item_dzq.name">
                            <a :href='item_dzq.url' target="_blank">点此签订</a>
                        </FormItem>
                    </div>
                    <div v-for="(item,index) in UploadViewArr" :key="index" >
                        <FormItem :label="item.value"  :prop="item.prop">
                            <div v-if="item.type=='file'">
                                <UploadImg :MaxSize="item.size"
                                           :MaxLength="item.maxLength"
                                           :Prop="item.prop"
                                           :Value="item.value"
                                           :FormatType="['jpg','jpeg','png']"
                                           :isValid="item.isValid"
                                           :ref="item.prop"
                                           @fatherImage="fatherImage"
                                           @loadingSpin="loadingSpin"
                                           :ChangedList="FormValidate[item.prop]"
                                           :Type="item.Type"
                                ></UploadImg>
                                <div v-if="item.Type==1||item.Type==2">
                                    <Button type="primary" 
                                    style="width:160px;background-color: #E4F2FF!important;border-color: #E4F2FF!important;color:#0F71B3"
                                    @click="Certification(item.Type)">获取{{item.value}}照</Button>
                                </div>
                            </div>
                        </FormItem>
                    </div>
                    <!--<p v-show="currentPage=='sbjy_jm'&&JFPZCnt==0&&FormValidate.BtnName=='提交'" style="margin:10px 0 10px 20px;">注：水表检验需要预收取15元的费用，请打款至以下银行账户后提供缴费凭证的图片进行上传：银行名称：中国建设银行苏州新区支行。银行账户：32201988636050852397</p>-->
                </div>

                <FormItem class="businessFormBtn"
                          v-show="FormValidate.BtnName=='提交'&&UploadViewArr.length>0
                        ||FormValidate.BtnName=='提交'&&['zlbg_jm','dbsq_jm','zzts_jm', 'fjsq_jm','ysxz_jm'].indexOf(currentPage)>-1
                        ||FormValidate.BtnName=='生成申请单'">
                    <Button type="primary" @click="SubmitAll('FormValidate')"  style="width:160px;">{{FormValidate.BtnName}}</Button>
                </FormItem>
            </Form>
        </div>

        <!-- <Modal v-model="PropertyModal" title="输入证件编号">
            <Form ref="FormProperty" :rules="RuleValidate" :label-width="120">
                <FormItem prop="S_Property" label="产权证编号">
                    <Input v-model="FormProperty.S_Property" type="text" placeholder="请输入产权证编号" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" @click="PropertyModal=false">取消</Button>
                <Button type="primary"  @click="GetDZZZ('Property')">确定</Button>
            </div>
        </Modal>

        <Modal v-model="HuZhuIDCardModal" title="确认户主身份证" width="550">
            <div style="text-align: center;">
                <img :src="HuZhuImg" title="证件照片" width="400" height="500">
            </div>
            <div slot="footer">
                <Button type="text" @click="HuZhuIDCardModal=false">取消</Button>
                <Button type="primary"  @click="SetImgData(CurrentImgProp)">确定</Button>
            </div>
        </Modal> -->

        <Spin size="large" fix v-if="SpinShow" ></Spin>

          <!--二维码显示-->
          <Modal v-model="qrcode" footer-hide title="" @on-visible-change="clearTimer">
            <div>
                <div style="height:240px;margin-top: 2rem;text-align: center;">
                    <img :src="QRcode">
                </div>
                <div style="text-align: center;">
                    <p style="margin-top:5px;font-size: 16px;">{{erweimaTxt}}</p>
                </div> 
            </div>
        </Modal>
        <!--房产证列表显示-->
         <Modal v-model="FaChangZhengList" footer-hide title="房产证列表">
             <Table :columns="FormImage.ColumnsValue" :data="FormImage.FormData" size="small" style="padding-top: 1rem;height:96%"></Table>
         </Modal>
         <!--房产证列表预览-->
         <Modal title="预览" v-model="Visible" width="720" height="650">
            <img :src="ImgURL"  v-if="Visible" style="width:100%;">
            <div slot="footer">
                 <Button type="text" @click="Visible=false">取消</Button>
                 <Button type="primary" @click="SetImgData">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import SelectRole from './SelectRole';
    import UploadImg from '../Other/UploadImg';
    import { Card,Divider,Cascader } from 'view-design';
    import SendMsg from '../../components/BaseEllipsis/SendMsg.vue'
    import { domain } from '@/api/apiConfig.js'
    export default {
        name: 'BusinessForm',
        props:["currentPage"],
        components:{
            SelectRole,
            UploadImg,
            Card,
            Divider,
            Cascader,
            SendMsg
        },
        data(e) {
            return {
                DomainApi:domain.InApi,
                FZCLCnt: 0,
                JFPZCnt: 0,
                CurrentPageTitle:'',//当前页面标题
                CurrentViewArr:[],//当前页面数组
                UploadViewArr:[],//当前页面提交申请单后显示的申请单内容
                ButtonDownArr:[],//当前页面提交申请单后的可下载单据
                DianZiQianArr:[],//可以电子签的单据
                I_Type:0,//当前页面类型提交
                WT_JFPZ: [], // 缴费凭证
                FormValidate: {
                    S_HM:"",
                    S_DZ:"",
                    S_CID:"",
                    WaterNature:"",
                    WaterArrears:"",
                    WaterPrice:"",
                    BZ:"",
                    PopulationNum:"",
                    S_CIDList:[],
                    Property:[],//产权证
                    PhoneNumShow:false,
                    PhoneNum:"",
                    NewPhone:"",//新手机号
                    WaterMeterNumericalValue:"",
                    LowGuarantee:[],//低保证明
                    LivePhotos:[],//水表照片
                    Householder:[],//户口本
                    FamilyMembers:[],//户口本全页
                    CommunityCertification:[],//社区证明
                    TemporaryResidencePermit:[],//暂住证
                    WaterMeterSteelSeal:"",//水表钢印号
                    HuZhuIDCard:[],//户主身份证
                    ExistingProblems:"",//存在问题
                    WT_Others: [], //申请辅助材料
                    S_XiaoQu:"",
                    S_Dong:"",
                    S_Shi:"",
                    S_Lu:"",
                    SelectList:{
                        TransferReason: {CurrentKey: '',List: []},
                        S_YeWuLX:{CurrentKey:'',List:[]},//{label:"单位或个人接用水",value:"1"},
                        S_YongTu:{CurrentKey:'',List:[]}
                    },
                    Cascader:{
                        ScheduledDate:[],
                        List:[{
                            value: '',
                            label: '',
                            children: []
                        }]},
                    BtnName:""
                },
                RuleValidate: {
                    S_CID: [{ required: true,trigger: 'change',validator:(rule, value, callBack)=>{
                            if (!value) { return callBack('客户编号不能为空');}
                            else {return callBack();}
                        }
                    }],
                    Reason:[{ required: true, message: '申请原因不能为空', trigger: 'blur' }],
                    PopulationNum:[{ required: true,trigger: 'blur',validator: (rule, value, callBack) => {
                            if (!value) {return callBack('人口数不能为空');}
                            else if (!/^[1-9]\d*$/.test(value)) {return callBack('人口数必须为数字');}
                            else if (value<=4 && e.currentPage=='jthd_jm') {return callBack('人口数必须大于4');}
                            else if (value>50) {return callBack('人口数必须小于50');}
                            else {return callBack();}
                        }
                    }],
                    PersonName:[{ required: true,trigger: 'blur',validator:(rule, value, callBack)=>{
                            if (!value) { return callBack('姓名不能为空');}
                            else if (!/^([\u4E00-\u9FA5])+$/.test(value)) {return callBack('姓名必须为中文');}
                            else {return callBack();}
                        }
                    }],
                    PersonID:[{ required: true,trigger: 'blur',validator:function(rule, value, callback){
                            if(!value){
                                return callback(new Error("身份证号码不能为空"));
                            }else if(!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)){
                                return callback(new Error("身份证号码格式不正确"))
                            }else{
                                return callback();
                            }
                        }}],
                    Property:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.Property.length>0){return callback(); }
                            else{return callback(new Error("请上传产权证"));}
                        }
                    }],
                    LowGuarantee:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.LowGuarantee.length>0){return callback(); }
                            else{return callback(new Error("请上传低保证"));}
                        }
                    }],
                    NewPhone: [{ required: true, trigger: 'blur',validator: function(rule, value, callback){
                            let reg = /^1[3456789]\d{9}$/;
                            if (value == '') {return callback('新手机号不能为空');}
                            else if (!reg.test(value)) {return callback('手机号码格式错误');}
                            else {return callback();}
                        }}],
                    PhoneVaild:[{ required: true, message: '验证码不能为空', trigger: 'blur' }],
                    WaterMeterNumericalValue:[{ required: true,trigger: 'blur',validator: function(rule, value, callback){
                            if(!value){return callback(new Error("水表读数不能为空"));}
                            else if(!/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value)){return callback(new Error("水表读数必须为数字"))}
                            else{ return callback();}
                        }
                    }],
                    LivePhotos:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.LivePhotos.length>0){return callback(); }
                            else{return callback(new Error("请上传水表照片"));}
                        }
                    }],
                    HuZhuIDCard:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.HuZhuIDCard.length>0){return callback(); }
                            else{return callback(new Error("请上传户主身份证"));}
                        }
                    }],
                    Populations:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            let _hasDynamic=e.FormDynamic.items.filter(n=>n.PersonName==''||n.PersonID=='');
                            if(_hasDynamic.length>0){return callback(new Error("请填写全员信息")); }
                            else{return callback();}
                        }
                    }],
                    Householder:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.Householder.length>0){return callback(); }
                            else{return callback(new Error("请上传户口本户主页"));}
                        }
                    }],
                    FamilyMembers:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.FamilyMembers.length>0){return callback(); }
                            else{return callback(new Error("请上传户口本全页"));}
                        }
                    }],
                    WT_JFPZ:[{required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.WT_JFPZ.length>0){return callback(); }
                            else{return callback(new Error("请上传缴费凭证"));}
                        }}],
                    CancellationReason: [{ required: true, message: '注销原因不能为空', trigger: 'blur' }],
                    TransferReason:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.SelectList.TransferReason.CurrentKey){return callback(); }
                            else{return callback(new Error("过户原因不能为空"));}
                        } }],
                    S_YeWuLX:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            if(e.FormValidate.SelectList.S_YeWuLX.CurrentKey){return callback(); }
                            else{return callback(new Error("业务类型不能为空"));}
                        } }],
                    S_YongTu:[{ required: true, trigger: 'change',validator: function(rule, value, callback){
                            let _currentYongTu=e.FormValidate.SelectList.S_YongTu.CurrentKey;
                            if(!_currentYongTu){return callback(new Error("建筑物用途不能为空"));}
                            else if(_currentYongTu&&_currentYongTu!=4){e.RuleValidate.S_YongTuSM[0].required=false;return callback();}
                            else if(_currentYongTu&&_currentYongTu==4){e.RuleValidate.S_YongTuSM[0].required=true;return callback();}
                            else{return callback();}
                        } }],
                    S_YongTuSM: [{ required: false, message: '其它用途说明不能为空', trigger: 'blur' }],
                    D_YongShuiL:[{ required: true,trigger: 'blur',validator: function(rule, value, callback){
                            if(!value){return callback(new Error("用水量不能为空"));}
                            else if(!/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value)){return callback(new Error("用水量只能为正整数"))}
                            else{return callback();}
                        }}],
                    S_XiaoFangQK:[{ required: true,trigger: 'blur',validator:(rule, value, callback)=>{
                            if (!value) { return callback('消防情况不能为空');}
                            else {return callback();}
                        }}],
                    S_KeHuDZ:[{ required: true, trigger: 'blur',validator: function(rule, value, callback){
                            if (!value) { return callback('用水地址不能为空');}
                            else {return callback();}
                        } }],
                    S_Property:[{ required: true, trigger: 'blur',validator: function(rule, value, callback){
                        if (!e.FormProperty.S_Property) { return callback('产权证号不能为空');}
                        else {return callback();}
                    } }],
                },
                FormDynamic:{
                    items: [{PersonName: '',PersonID:'',Index: 1}]
                },
                SelectRole: '',
                SpinShow:false,
                Sending:false,
                S_AnJuanID:"",
                XieYiWJList:"",
                DescList:[],//描述
                DescLink:"",//描述文件链接
                PropertyModal:false,
                HuZhuIDCardModal:false,
                HuZhuIDCardData:{
                    S_HuZhu: '',
                    S_ZhengJianLX:'',
                    S_ZhengJianHao: ''
                },//户主信息
                FormProperty:{
                    S_Property:"",
                },
                DZZZList:[],//电子证照照片，包括户主身份证、产权证
                HuZhuImg:"",
                CurrentImgProp:"HuZhuIDCard",//HuZhuIDCard或WT_JSSFZ
                 //二维码
                 qrcode:false,
                QRcode:"",
                token:"",
                typeQueryCode:"",
                erweimaTxt:"请用皖事通app扫描认证",
                tokenStatus:false,
                timer:null,
                handleSubNo:"",//身份证
                FaChangZhengList:false,
                FileType:"",
                Visible:false,
                ImgURL:"",
                FormImage:{
                    ColumnsValue:[
                        {title: '房产证',key: 'infoCode',align: 'center'},                       
                        // {title: 'id',key: 'id',align: 'center',show:false},
                        // {title: 'token',key: 'token',align: 'center',show:false},
                        // {title: 'format',key: 'format',align: 'center',show:false},                
                        {title: '查看',align: 'center',
                            render: (h, params) => {
                                console.log(params)
                                return   h('p', {
                                    style: {
                                        color:"#1E94EC",
                                        fontSize: "0.8rem",
                                        cursor:"pointer"
                                    },
                                    on: {
                                        click: () => {                                           
                                            this.UploadZhengZhaoOnly(h,params);
                                        }
                                    }
                                }, '查看图片');
                            }
                        },
                    ],
                    FormData:[]
                }
            }
        },
        computed: {
            ScidDataList(){
                return this.$store.state.GetScid.S_CIDList;
            }
        },
        created() {
            this.InitPage();
            if(this.ScidDataList&&this.ScidDataList.length<=0){
                this.$store.commit("GetScid");
            }
            if(this.currentPage=="yhfzxz_jm"){
                this.JSSQ_GetWords();
            }
        },
        watch: {
            qrcode(newVal){
            if (!newVal) {
                let that = this 
                clearInterval(that.timer);
                that.timer=null;
            }
            }
        },
        beforeDestory(){
            let that = this 
            clearInterval(that.timer);
            that.timer=null;
        },
        methods: {
            InitPage() {
                //20230918如有户主身份证、产权证则调用接口获取信息，用户确认后填入图片
                switch (this.currentPage) {
                    case "ghsq_jm": //变更过户
                        this.CurrentViewArr = [
                            { value: "过户原因", isValid: true, type: "select", prop: "TransferReason" },
                            { value: "户主身份证", isValid: true, type: "file", prop: "HuZhuIDCard", size: "10", maxLength: '5' ,Type:"1"},
                            { value: "产权证", isValid: true, type: "file", prop: "Property", size: "10", maxLength: '5',Type:"2"},
                            { value: "备注", isValid: false, type: "textarea", prop: "Remark"},
                        ];
                        this.I_Type = 0;
                        this.FormValidate.BtnName="生成申请单";
                        this.DescList=[
                            { desc:"1、实名认证后，输入客户编号"},
                            { desc:"2、网厅检测此客户编号是否欠费，如有欠费则需欠费交清"},
                            { desc:"3、上传房产证、户主本人身份证"},
                            // { desc:"4、人口数填写。以户籍人口4人（含4人）为计价单位，以年度为计量周期。对户籍人口超过4人的，每增加1人，各梯次按每人增加年用水量54立方米依次调整。"},
                            { desc:"4、网厅人员审核完成后签订供用水合同，流程结束"}
                        ];
                        this.DescLink=this.DomainApi+"Resource/DescImg/ghsq_jm.jpg";
                        this.GetTransferReason();
                        break;
                    case "ysxz_jm"://用水性质变更
                        this.CurrentViewArr = [
                            {value: "申请原因", isValid: true, type: "textarea", prop: "Reason"},
                            {value: "户主身份证", isValid: true, type: "file", prop: "HuZhuIDCard", size: "10", maxLength: '5',Type:"1" },
                            {value: "产权证", isValid: true, type: "file",prop: "Property", size: "10", maxLength: '5',Type:"2"},
                        ];
                        this.I_Type = 1;
                        this.FormValidate.BtnName="提交";
                        this.DescList=[
                            { desc:"1、用户提交变更用水性质需书面申请、房产证复印件、营业执照复印件（商业用水需提供）、身份证复印件（如非本人办理需委托授权书及经办人身份证）"},
                        ];
                        this.DescLink=this.DomainApi+"Resource/DescImg/ysxz_jm.jpg";
                        break;
                    case "jthd_jm"://阶梯核定
                        this.CurrentViewArr = [
                            {value: "人口数", isValid: true, type: "input", prop: "PopulationNum"},
                            {value: "全员信息", isValid: true, type: "inputs", prop: "Populations"},
                            {value: "户口本户主页", isValid: true, type: "file",prop: "Householder", size: "10", maxLength: '5' },
                            {value: "户口本全页", isValid: true, type: "file", prop: "FamilyMembers", size: "10", maxLength: '5'},
                            {value: "备注", isValid: false, type: "textarea",prop: "Remark"},
                        ];
                        this.I_Type = 2;
                        this.FormValidate.BtnName="生成申请单";
                        this.DescList=[
                            { desc:"1、以户籍人口4人（含4人）为计价单位，以年度为计量周期"},
                            // { desc:"2、对户籍人口超过4人的，每增加1人，各梯次按每人增加年用水量54立方米依次调整"},
                            { desc:"提供资料的注意事项："},
                            { desc:"a）申请人口均在同一户口本上：户口本户主页、户口本全页（户口本上地址需与申请增加人口地址一致）"},
                          ];
                        this.DescLink=this.DomainApi+"Resource/DescImg/jthd_jm.jpg";
                        break;
                    case "zxsq_jm"://注销申请
                        this.CurrentViewArr = [
                            { value: "注销原因", isValid: true, type: "input", prop: "CancellationReason" },
                            {value: "产权证", isValid: true, type: "file", prop: "Property", size: "10", maxLength: '5',Type:"2"}
                        ];
                        this.DescList=[
                            { desc:"1、上传图片最多不能超过10M"},
                          ];
                        this.FormValidate.BtnName="生成申请单";
                        this.I_Type = 5;
                        this.GetCascaderData();
                        break;
                    case "zlbg_jm"://资料变更
                        this.CurrentViewArr = [
                            {value: "新手机号", isValid: true, type: "inputVaild", prop: "NewPhone"},
                            {value: "验证码", isValid: true, type: "input", prop: "PhoneVaild"},
                            {value: "产权证", isValid: true, type: "file", prop: "Property", size: "10", maxLength: '5',Type:"2"}
                        ];
                        this.DescList=[
                            { desc:"1、上传图片最多不能超过10M"},
                          ];
                        this.FormValidate.BtnName="提交";
                        this.FormValidate.PhoneNumShow=true;
                        this.I_Type = 6;
                        break;
                    case "yhfzxz_jm"://接水申请
                        this.CurrentViewArr=[
                            {value:"业务类型", isValid: true, type: "select", prop: "S_YeWuLX"},
                            {value:"建筑物用途", isValid: true, type: "select", prop: "S_YongTu"},
                            {value:"其它用途说明", isValid: false, type: "input", prop: "S_YongTuSM"},
                            {value: "用水地址", isValid: true, type: "input", prop: "S_KeHuDZ"},
                            {value: "备注", isValid: false, type: "input", prop: "Remark"},
                        ];
                        this.DescList=[
                            { desc:"1、上传图片最多不能超过10M"},
                          ];
                        this.FormValidate.BtnName="生成申请单";
                        this.I_Type = 17;
                        break;
                    default:
                        break;
                }
            },
            ScidBlur(item) {
                item.value!=""&&item.value!=undefined?this.FormValidate.S_CID=item.value:this.FormValidate.S_CID="";
                if(!this.FormValidate.S_CID){return false}
                let that=this;
                that.FormValidate.S_CID=that.FormValidate.S_CID.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
                let _scid=that.FormValidate.S_CID.split("");
                if(_scid.length!=13){
                    that.$Notice.warning({title: '提示',desc: '您输入的客户编号不存在！'});
                    that.FormValidate.S_HM="";
                    that.FormValidate.S_DZ="";
                    that.FormValidate.S_CID="";
                    that.FormValidate.WaterPrice="";
                    that.FormValidate.WaterNature="";
                    that.FormValidate.WaterArrears="";
                    that.$refs.SelectScidRef.query="";
                    return false;
                }
                that.InApi("api/waterbill/waterbill/GetNowMonthBillInfo", { UserNo:this.FormValidate.S_CID },"get").then(function (response) {
                    if(!response)return false;
                    let _data=JSON.parse(response);
                    let jsonData = JSON.parse(_data.DataMain)[0];
                    let waterInfoData = JSON.parse(_data.UserInfo)[0];
                    if (!jsonData.CustomerNO) {
                        that.$Notice.warning({title: '提示',desc: '您输入的客户编号不存在！'});
                        that.FormValidate.S_HM="";
                        that.FormValidate.S_DZ="";
                        that.FormValidate.S_CID="";
                        that.FormValidate.WaterPrice="";
                        that.FormValidate.WaterNature="";
                        that.FormValidate.WaterArrears="";
                        that.$refs.SelectScidRef.query="";
                        return false;
                    }
                    /* if (waterInfoData.S_ST == "20") {
                        that.$Notice.warning({title: '提示',desc: '本网厅服务范围仅限马鞍山首创水务供水区域（花山区、雨山区），请知悉！'});
                        return false;
                    } */
                    let _koujing =waterInfoData.I_KouJingSZ;
                    if (parseInt(_koujing) >= 50 && that.currentPage =="sbjy_jm") {
                        that.$Notice.warning({title: '提示',desc: '当前水表口径大于等于DN50，如有疑异可直接前往苏州市场监督局计量处诉讼'});
                        that.FormValidate.S_HM="";
                        that.FormValidate.S_DZ="";
                        that.FormValidate.S_CID="";
                        that.FormValidate.WaterPrice="";
                        that.FormValidate.WaterNature="";
                        that.FormValidate.WaterArrears="";
                        that.$refs.SelectScidRef.query="";
                        return false;
                    }
                    that.FormValidate.S_HM=waterInfoData.userName;
                    that.FormValidate.S_DZ=waterInfoData.userAddress;
                    that.FormValidate.WaterPrice=waterInfoData.waterPrice;
                    that.FormValidate.WaterNature=waterInfoData.S_JH;
                    that.FormValidate.WaterArrears=jsonData.PayMoney;
                    that.$store.commit("GetScid",{value:item.value,label:item.value});
                    that.FormValidate.S_CID=item.value;
                });
            },
            GetCascaderData(){
                let that=this;
                that.InApi("api/Flow/flow/P_GetYuYueSJ", {},"get").then(function (response) {
                    if(!response)return false;
                    let _data = response;
                    if (_data.length<=0) {return false;}
                    let _casArr=[];
                    _data.forEach(function(item){
                        let _childs=[];
                        (item.childs).forEach(function(qq){
                            _childs.push({value: qq.value,label: qq.value})
                        });
                        _casArr.push({
                            value: item.value,
                            label:item.id,
                            children: _childs
                        });
                    });
                    that.FormValidate.Cascader.List=_casArr;
                });
            },
            JSSQ_GetWords(){
                let that=this;
                that.InApi("api/Flow/Flow/GetWordsValue", {DaLeiKey: "JSSQYeWuLX_jm", XiaoLeiKey: ""},"get").then(function (response) {
                    if(!response)return false;
                    let _data = JSON.parse(response);
                    if (_data.length<=0) {return false;}
                    _data.forEach(function(item){
                        that.FormValidate.SelectList.S_YeWuLX.List.push({label:item.S_XiaoLeiMC,value:item.S_XiaoLeiKey});
                    });
                });
                that.InApi("api/Flow/Flow/GetWordsValue", {DaLeiKey: "JSSQYongTu_jm", XiaoLeiKey: ""},"get").then(function (response) {
                    if(!response)return false;
                    let _data = JSON.parse(response);
                    if (_data.length<=0) {return false;}
                    _data.forEach(function(item){
                        that.FormValidate.SelectList.S_YongTu.List.push({label:item.S_XiaoLeiMC,value:item.S_XiaoLeiKey});
                    });
                });
            },
            GetTransferReason() {
                let that=this;
                that.InApi("api/flow/flow/GetWordsValue?DaLeiKey=guohuyy_jm"+"&XiaoLeiKey=" ,{},"get").then(function (response) {
                    if(!response)return false;
                    let _data=JSON.parse(response);
                    if (_data.length<=0) {return false;}
                    that.FormValidate.SelectList.TransferReason.List=[];
                    _data.forEach(function(item){
                        that.FormValidate.SelectList.TransferReason.List.push({label:item.S_XiaoLeiMC,value:item.S_XiaoLeiKey});
                    });
                });
            },
            GetValidCode:function(){
                if(this.Sending) return;
                let _self=this;
                if(_self.FormValidate.NewPhone=="") {return;}
                if(_self.FormValidate.NewPhone.split("").length<=10){_self.$Message.error("请输入正确的手机号");return;}
                _self.$refs.btn[0].run();   //开始倒计时
                _self.Sending=true; //禁用重新发送按钮
                setTimeout(function(){_self.Sending=false}, 60000);
                _self.$store.commit("GetValidCode",_self.FormValidate.NewPhone);
            },
            GetFlowSQD(AnJuanID){
                let that=this;
                that.InApi("api/Flow/flow/GetFlowSQD", {S_AnJuanID:AnJuanID}, "get",).then(response => {
                    if (!response) return false;
                    that.CurrentViewArr.forEach(function(item){
                        if(item.type=="file"){
                            let _prop=item.prop;
                            that.$refs[_prop][0].HideIt="HideItClass";//隐藏图片
                        }
                    });
                    that.UploadViewArr=[];
                    that.ButtonDownArr=[];
                    that.DianZiQianArr=[];
                    that.FZCLCnt = 0;
                    that.JFPZCnt = 0;
                    response.forEach(function(item){//I_Type==0下载上传1签订协议
                        if (item.I_QianDingFlag == 0) {
                            if(item.I_Type==0){
                                if (item.S_DocUrl != "") {
                                    that.ButtonDownArr.push({name:  item.TemplateName, url:item.S_DocUrl});
                                }
                                that.UploadViewArr.push({value: item.TemplateName, isValid: true, type: "file", prop: item.S_DocType, size: "10", maxLength: '5',Type:(item.TemplateName=="身份证"?"1":"2")});
                                that.FormValidate[item.S_DocType]=[];
                                that.RuleValidate[item.S_DocType]=[{required: true, trigger: 'change',validator: function(rule, value, callback){
                                        if(that.FormValidate[item.S_DocType].length>0){return callback(); }
                                        else{return callback(new Error("请上传"+item.TemplateName));}
                                    }
                                }];
                            }else{
                                if (item.S_DocUrl != "") {
                                    that.DianZiQianArr.push({name: item.TemplateName, url:item.S_DocUrl});
                                } else {
                                    that.UploadViewArr.push({value: item.TemplateName, isValid: true, type: "file", prop: item.S_DocType, size: "10", maxLength: '5',Type:(item.TemplateName=="身份证"?"1":"2")});
                                    that.FormValidate[item.S_DocType]=[];
                                    that.RuleValidate[item.S_DocType]=[{required: true, trigger: 'change',validator: function(rule, value, callback){
                                            if(that.FormValidate[item.S_DocType].length>0){return callback(); }
                                            else{return callback(new Error("请上传"+item.TemplateName));}
                                        }
                                    }];
                                }
                            }
                        } else if (item.I_QianDingFlag == 1){
                            if (item.S_DocType == "WT_Others") {
                                // that.FZCLCnt = that.FZCLCnt +1;
                            } else if (item.S_DocType == "WT_JFPZ")
                            {
                                that.JFPZCnt = that.JFPZCnt + 1;
                            }
                        }
                    });
                    // var _Obj;
                    // if (that.FZCLCnt == 0) {
                    //     _Obj = { value: "申请辅助材料", isValid: false, type: "file", prop: "WT_Others", size: "10", maxLength: '5' };
                    //     that.UploadViewArr.push(_Obj);
                    // }
                });
            },
            SubmitAll(name) {
                let that = this;
                let roleValid=that.$refs.RoleForm.ValidateRole();
                that.$refs[name].validate((valid) => {
                    if (valid) {
                        if(!roleValid){return false;}
                        // 如果已经提交申请单，则直接第二步
                        let _limitYeWu=["zlbg_jm","dbsq_jm","zzts_jm","fjsq_jm","ysxz_jm"];
                        if(that.FormValidate.BtnName=="提交"&&that.S_AnJuanID!=""&&_limitYeWu.indexOf(that.currentPage)==-1){
                            that.UploadRecord(name);
                            return false;
                        }
                        // 如果是新增的单子，则第一步
                        let FlowXX = {
                            HuZhu: that.SelectRole,
                            S_CID: that.FormValidate.S_CID,
                            I_Type: that.I_Type,
                        };

                        //阶梯核定核对全员信息\过户申请人口数大于4核对全员信息
                        if(that.currentPage=="jthd_jm"||(that.currentPage=="ghsq_jm"&&that.FormValidate.PopulationNum>4)){
                            let validFamily = (that.FormDynamic.items).filter(n => n.PersonName&& n.PersonID);
                            if (validFamily.length <= 0) {
                                that.$Notice.error({title: '您的全员信息未填写完整'});
                                return false;
                            }
                            let familyArr = [];
                            (this.FormDynamic.items).forEach((item) => {
                                let _obj = {personName: item.PersonName, personID: item.PersonID};
                                familyArr.push(_obj);
                            });
                            if (familyArr.length != parseInt(that.FormValidate.PopulationNum)) {
                                that.$Notice.error({title: '全员信息应与人口数匹配'});
                                return false;
                            }
                            FlowXX["Populations"]=familyArr;
                        }


                        //过户申请判断照片是否户口本、社区证明、暂住证二选一
                        // if (that.currentPage == "ghsq_jm"&&that.FormValidate.PopulationNum>4) {
                        //     let _ghsq2in1 = ["Householder", "CommunityCertification"];
                        //     let _res2in1=0;
                        //     _ghsq2in1.forEach(function(item){
                        //         let _is2in1 = that.FormValidate[item];
                        //         if(_is2in1.length<=0){
                        //             _res2in1++;
                        //         }
                        //     });
                        //     if(_res2in1==2){
                        //         that.$Notice.error({title: '户口本/社区证明至少二选一'});
                        //         return false;
                        //     }
                        // }

                        //阶梯水价判断照片是否户口本、社区证明、暂住证三选一
                        // if (that.currentPage == "jthd_jm") {
                        //     let _jthd3in1 = ["Householder", "CommunityCertification", "TemporaryResidencePermit"];
                        //     let _res3in1=0;
                        //     _jthd3in1.forEach(function(item){
                        //         let _is3in1 = that.FormValidate[item];
                        //         if(_is3in1.length<=0){
                        //             _res3in1++;
                        //         }
                        //     });
                        //     if(_res3in1==3){
                        //         that.$Notice.error({title: '户口本/社区证明/暂住证至少三选一'});
                        //         return false;
                        //     }
                        // }

                        if(that.currentPage=="ghsq_jm"&&that.currentPage=="ysxz_jm"){
                            FlowXX["S_JiaoFenFS"]="现金";
                        }

                        let jsonArr = {};
                        let obj = that.FormValidate;
                        Object.keys(obj).forEach(function (key) {
                            if(key!="S_CIDList"&&key!="PhoneNumShow"&&key!="Cascader"){//跳过为复接类型显示list
                                FlowXX[key]=obj[key];
                            }else if(key=="Cascader"){
                                FlowXX["ScheduledDate"]=obj[key].ScheduledDate[0];//["2020-08-27", "15:00-16:00"]
                                FlowXX["ScheduledTime"]=obj[key].ScheduledDate[1];
                            }
                        });

                        let _select=that.FormValidate.SelectList;
                        Object.keys(that.FormValidate.SelectList).forEach(function(item){//select中的obj轮询
                            FlowXX[item]=_select[item].CurrentKey;
                        });

                        //*******获取已上传的图片地址*******
                        that.CurrentViewArr.forEach(function(item){
                            if(item.type==="file"){
                                let _key=item.prop;
                                let ResUploadUrl=[];
                                that.FormValidate[_key].forEach(function(item){
                                    ResUploadUrl.push(item);
                                });
                                jsonArr[_key]=ResUploadUrl;
                            }
                        });
                        const sendObj = Object.assign(FlowXX, jsonArr);
                        if(that.currentPage=="zlbg_jm"){
                          that.$store.commit("PhoneSecret", sendObj.NewPhone);
                          sendObj.NewPhone=that.$store.state.PhoneSecret.SendObj;
                        }
                        console.log(sendObj);
                        that.SpinShow = true;
                        that.InApi("api/Flow/flow/FlowStart_New", sendObj, "post",).then(response => {
                            if(!response)return false;
                            that.SpinShow = false;
                            let _data = response;
                            if (_data.ReturnCode == false) {
                                that.$Notice.error({title: '提示', desc: _data.ErrorMessage!=""?_data.ErrorMessage:"提交失败"});
                                return false;
                            }
                            if(that.currentPage!="ghsq_jm"&&that.currentPage!="zxsq_jm"){
                                that.$Notice.success({title: '提示', desc: _data.ErrorMessage!=""?_data.ErrorMessage:"提交成功", duration: 0});
                            }
                            that.S_AnJuanID=_data.ReturnMessage;
                            that.XieYiWJList=_data.XieYiWJList==null?"":_data.XieYiWJList;
                            if(_data.I_IsQianFei!=-1){
                                that.FormValidate.BtnName="提交";
                                that.$refs.RoleForm.RoleDisabled=true;
                                let _limitYeWu=["zlbg_jm","dbsq_jm","zzts_jm","fjsq_jm","ysxz_jm"];
                                if(_limitYeWu.indexOf(that.currentPage)>-1){
                                    that.$refs.RoleForm.RoleDisabled=false;
                                    that.$refs['FormValidate'].resetFields();
                                    that.CurrentViewArr.forEach(function(item){
                                        if(item.type=="file"){
                                            let _prop=item.prop;
                                            that.$refs[_prop][0].Reset();//清空图片
                                        }
                                    });
                                    if(that.currentPage=="ghsq_jm"||that.currentPage=="jthd_jm"){
                                        that.FormDynamic.items=[{PersonName: '',PersonID:'',Index: 1}];
                                    }
                                    if(that.currentPage=="zxsq_jm"||that.currentPage=="btsq_jm"||that.currentPage=="fjsq_jm"||that.currentPage=="sbjy_jm"){
                                        that.FormValidate.Cascader.ScheduledDate=[];
                                    }
                                }else{
                                    //20240325过户、注销直接调用上传协议接口xiaohang
                                    if(that.currentPage=="ghsq_jm"||that.currentPage=="zxsq_jm"){
                                        that.ShangChuanXieYi();
                                    }else{
                                        that.GetFlowSQD(_data.ReturnMessage);
                                    }
                                }
                            }else{
                                that.$refs.RoleForm.RoleDisabled=false;
                                that.$refs['FormValidate'].resetFields();
                                that.CurrentViewArr.forEach(function(item){
                                    if(item.type=="file"){
                                        let _prop=item.prop;
                                        that.$refs[_prop][0].Reset();//清空图片
                                    }
                                });
                                if(that.currentPage=="ghsq_jm"||that.currentPage=="jthd_jm"){
                                    that.FormDynamic.items=[{PersonName: '',PersonID:'',Index: 1}];
                                }
                                if(that.currentPage=="zxsq_jm"||that.currentPage=="btsq_jm"||that.currentPage=="fjsq_jm"||that.currentPage=="sbjy_jm"){
                                    that.FormValidate.Cascader.ScheduledDate=[];
                                }
                            }
                        });
                    }
                });
            },
            UploadRecord(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let that=this;
                        let jsonArr={};
                        that.UploadViewArr.forEach(function(item){
                            if(item.type=="file"){
                                let _key=item.prop;
                                let ResUploadUrl=[];
                                that.FormValidate[_key].forEach(function(item){
                                    ResUploadUrl.push(item)
                                });
                                jsonArr[_key]=ResUploadUrl;
                            }
                        });
                        let FlowXX={
                            S_FlowFlag:"申请审核",
                            S_NodeID: "lcfq",
                            S_RenWuID:that.S_AnJuanID,
                            WangTingOrLeaRun:""
                        };
                        let sendObj = Object.assign(FlowXX,jsonArr);
                        console.log(sendObj);
                        that.SpinShow=true;
                        that.InApi("api/Flow/flow/ShangChuanXieYi", sendObj, "post",).then(response => {
                            if(!response)return false;
                            that.SpinShow=false;
                            let _data = response;
                            if(_data.ReturnCode==false) {
                                that.$Notice.error({title:'提示',desc: _data.ReturnMessage});
                                return false;
                            }
                            let _ReturnMessage = (_data.ErrorMessage == "" || _data.ErrorMessage == null) ? "提交成功" : _data.ErrorMessage;
                            that.$Notice.success({title: '提示', desc: _ReturnMessage, duration: 0});
                            that.FormValidate.BtnName="生成申请单";
                            that.$refs.RoleForm.RoleDisabled=false;
                            that.$refs['FormValidate'].resetFields();
                            that.CurrentViewArr.forEach(function(item){
                                if(item.type=="file"){
                                    let _prop=item.prop;
                                    that.$refs[_prop][0].Reset();//清空图片
                                    that.$refs[_prop][0].HideIt="";//显示图片
                                }
                            });
                            if(that.currentPage=="ghsq_jm"||that.currentPage=="jthd_jm"){
                                that.FormDynamic.items=[{PersonName: '',PersonID:'',Index: 1}];
                            }
                            if(that.currentPage=="zxsq_jm"||that.currentPage=="btsq_jm"||that.currentPage=="fjsq_jm"||that.currentPage=="sbjy_jm"){
                                that.FormValidate.Cascader.ScheduledDate=[];
                            }
                        });
                    }
                });
            },
            CurrentRoleData(item) {
                this.SelectRole = item;
            },
            HandleRemoveInfo(index) {
                this.FormDynamic.items.splice(index, 1);
            },
            HandleAdd() {
                this.index++;
                this.FormDynamic.items.push({
                    PersonName: '',
                    PersonID: '',
                    Index: this.index,
                });
            },
            fatherImage(file){
                console.log(file)
                this.FormValidate[file.prop]=file.length>0?file:[];
            },
            loadingSpin(status){
                this.SpinShow=status;
            },
            ShowDZZZModal(prop){
                let that = this;
                if(!that.SelectRole){
                    that.$Notice.error({title:'提示',desc: "请先选择户主身份证"});
                    return false;
                }
                if(prop=="HuZhuIDCard"||prop=="WT_JSSFZ"){
                    //户主身份证先验证是否已选择，如选择则调用接口验证
                    that.GetDZZZ(prop);
                }else{
                    //产权证需弹出让用户填写
                    that.PropertyModal=true;
                    that.CurrentImgProp = prop;
                }
            },
            GetDZZZ(prop){//获取电子证照
                let that = this;
                let SendType = "";
              //  let FileName = "";
                if(prop=="HuZhuIDCard"||prop=="WT_JSSFZ"){
                    SendType= {
                        "ThirdID":that.SelectRole,
                        "styleCode":"1",//1身份证 2中华人民共和国不动产权证书 3不动产登记证明
                        "ownerId":"",
                        "InfoCode":""
                    };
                  //  FileName = "户主身份证";
                }else if(prop=="Property"||prop=="WT_JSCQZ"){
                    let IsVaild = false;
                    that.$refs['FormProperty'].validate((valid) => {
                        if (valid) {
                            IsVaild = true;
                        }
                    });
                    if(IsVaild==false){
                        return false;
                    }
                    SendType= {
                        "ThirdID":that.SelectRole,
                        "styleCode": "2",
                        "ownerId": "",//不动产单元号
                        "InfoCode":that.FormProperty.S_Property,//不动产证件号（非必填）
                    };
                   // FileName = "产权证";
                }
                that.SpinShow=true;
                that.InApi("api/LicenseSharing/LicenseSharing/GetCertificate", SendType, "post",).then(response => {
                    if(!response)return false;
                    that.SpinShow=false;
                    let _data = JSON.parse(response);
                    if(_data.ReturnCode==false) {
                        that.$Notice.error({title:'提示',desc: _data.ReturnMessage});
                        return false;
                    }
                    let ImgList = [];
                    JSON.parse(_data.data).forEach((e) => {
                        let CurrentItem = JSON.parse(JSON.parse(e)).Data;
                        ImgList.push(CurrentItem);
                    });
                    that.DZZZList = ImgList;
                    if(prop=="HuZhuIDCard"||prop=="WT_JSSFZ"){
                        //用户确认户主信息后赋照片信息
                        that.HuZhuIDCardModal = true;
                        that.CurrentImgProp = prop;
                        that.HuZhuImg = that.DomainApi+ImgList[0].path; //照片赋值
                    }else{
                        that.PropertyModal = false;
                        //直接赋照片信息
                        that.SetImgData(that.CurrentImgProp);
                    } 
                });
            },
            // SetImgData(prop){
            //     let that = this;
            //     let CurrentData = [];
            //     that.DZZZList.forEach((item)=>{
            //         CurrentData.push({ 
            //             "originalName": item.originalName,
            //             "newName": item.newName,
            //             "path": item.path,
            //             "uploadDate": item.uploadDate,
            //             fileId: prop,
            //             fileName:prop=="HuZhuIDCard"?"户主身份证":prop=="WT_JSSFZ"?"身份证":"产权证",
            //         })
            //     });
            //     CurrentData["prop"]=prop;
            //     that.FormValidate[prop].push(CurrentData);
            //     that.fatherImage(CurrentData);
            //     prop=="HuZhuIDCard"||prop=="WT_JSSFZ"?that.HuZhuIDCardModal = false:"";
            // },
            //以下为使用政务网token皖事通获取身份证、获取产权证方法
            Certification(type){
                console.log(type);
                 //获取到二维码
                 if(type=="2"){
                     this.TokenStatus(type)
                 }else{                    
                     this.TokenStatus(type)
                 }                                                       
            },
            TokenStatus(BtnType){
                let that = this;
                if(that.token==""){
                    that.timer=setInterval(that.GetTokenStatus,5000,["1",BtnType]);
                    that.RestReqAuthOnline();
                    //that.qrcode = true;
                    //轮询获取扫描二维码的的认证状态
                }else{
                    //that.RestReqAuthOnline(BtnType);
                    that.GetTokenStatus(["2",BtnType]);
                }

            },
            //获取token 二维码
            RestReqAuthOnline(){
                let that = this;
                let ThirdID ="";
                ThirdID = that.SelectRole;
                if(!ThirdID){
                  that.$nextTick(()=>{
                    that.qrcode = false;
                  });
                  that.$Notice.error({title: '提示', desc: "请先选择用户"});
                  clearInterval(that.timer);
                  that.timer = null;
                  return false;
                } 
                 let typeCode="";
                 if(that.currentPage=="ghsq_jm"||that.currentPage=="ysxz_jm"||that.currentPage=="bzyy_jm"||that.currentPage=="yhfzxz_jm"){
                     typeCode ="1,2"
                 }else if(that.currentPage=="btsq_jm"||that.currentPage=="zxsq_jm"||that.currentPage=="zlbg_jm"){
                     typeCode = "2"
                 }else{
                      typeCode = "1"
                 }
                let data = {
/*                  handleSubName:"",
                    handleSubNo:"",
                    S_ThirdID:ThirdID,
                    handleBusiness:"办理业务",       
                    typeCode: 1,//类型 1身份证 2营业执照 3房产证
                    dataUseRange: "1,2,3", //数据使用范围1：证照材料信息，2：证照材料文件，3：证照照面信息
                    handleType: "1",//办理类型：1：自办，2：代办
                    useTerminal: "1",//使用终端：1：PC，2:APP
                    loginToken: "",//用户登录token（代办时必填）
                    agencySubName: "",//代办主体名称（代办时必填）
                    agencySubNo: "",//代办主体代码（代办时必填）
                    queryType: "1",//默认1：优先使用电子证照，无证照查询材料；2：仅使用电子证照；3：仅使用电子材料 */
                     typeCode: typeCode,//类型 1身份证 2房产证3营业执照
                     S_ThirdID:ThirdID,
                     useTerminal:"1",
                     handleType:"1"
                }
                
                that.InApi("api/WanShiTong/ShuiWuTong/RestReqAuthOnline",data,"post").then(result => {
                    if(!result) return false;
                    let _data = result;
                    if(_data.returnCode==false) {
                        that.$Notice.error({title: '提示', desc:_data.returnMessage||"未获取到对应类型的证照或材料"});
                        clearInterval(that.timer);
                        that.timer = null;
                        return false;
                    }
                    let returnData = JSON.parse(_data.returnData)
                    that.QRcode ='data:image/png;base64,'+ returnData.qrCode
                    that.token = returnData.token
                    that.typeQueryCode = returnData.typeQueryCode;
                    that.qrcode = true;
                    //that.$refs['FormInline'].resetFields();
                }) 
            },
            //获取认证状态
            GetTokenStatus([type,BtnType]){
                let CurrentType = BtnType;
                let that = this;
                let data = {
                    loginToken : that.token,
                    token : that.token
                }
                that.InApi("api/WanShiTong/ShuiWuTong/RestReqTokenStatus",data,"post").then(result => {
                    if(!result) return false;
                    let _data = result;
                    if(_data.returnCode==false) {
                       if(type=="2"){
                        that.RestReqAuthOnline(CurrentType);
                        that.qrcode = true;
                        //轮询获取扫描二维码的的认证状态
                        console.log(type,BtnType)
                        that.timer=setInterval(that.GetTokenStatus,5000,["1",BtnType]);
                       }
                        return false;
                    }
                    let returnData = JSON.parse(_data.returnData)
                    let handleSubName = returnData.handleSubName;
                    that.handleSubNo = returnData.handleSubNo;
                    console.log(handleSubName,that.handleSubNo)
                    //that.erweimaTxt="认证成功"
                    console.log(that.timer) 
                    clearInterval(that.timer);
                    that.timer = null;
                    that.UploadZhengZhao(CurrentType);
                    that.qrcode = false;
                    that.tokenStatus=true;                                                      
                })                    
            },
            //获取证件照
            UploadZhengZhao(BtnType){
                 let that = this;
                 let data = {
                     token:that.token,
                     typeCode:BtnType,
                     //subNo:that.handleSubNo,
                     typeQueryCode:that.typeQueryCode
                 }
                 console.log(data)
                 
                  that.InApi("api/WanShiTong/ShuiWuTong/UploadZhengZhao",data,"post").then(result => {
                    that.SpinShow=false;
                      if(!result) return false;
                      let _data = result;
                      if(_data.returnCode==false) {
                         that.$Notice.error({title: '提示', desc: _data.returnMessage});
                         return false;
                      } 
                      if(_data.returnData==""){
                         that.$Notice.error({title: '提示', desc: "您没有证件照"});
                         return false;
                      }
                      console.log(JSON.parse(_data.returnData))                                          
                      let _responseFile={fileId:that.Prop,
                          fileName:that.Value,
                          path:JSON.parse(_data.returnData).FileUrl
                      } 
                     if(BtnType=="1"){
                         let returnDataFileUrl = JSON.parse(_data.returnData).FileUrl
                         console.log(returnDataFileUrl);
                        //  console.log(that.$refs.HuZhuIDCard[0].ImgList);
                         _responseFile={
                             fileId:"HuZhuIDCard",
                             fileName:"身份证件号",
                             path:returnDataFileUrl[0]
                        } 
                        if(that.currentPage=="yhfzxz_jm"){
                            console.log(that.$refs.WT_JSSFZ[0]);
                            
                            that.$refs.WT_JSSFZ[0].ImgList.push(_responseFile);
                            that.$refs.WT_JSSFZ[0].ImgList["prop"]="WT_JSSFZ";
                            that.FormValidate.WT_JSSFZ.push(_responseFile);
                            clearInterval(that.timer);
                            that.timer = null;
                        }else{
                            that.$refs.HuZhuIDCard[0].ImgList["prop"]="HuZhuIDCard";
                            //that.$refs.HuZhuIDCard[0].ImgList.push(_responseFile);
                            that.FormValidate.HuZhuIDCard.push(_responseFile);
                            clearInterval(that.timer);
                            that.timer = null;
                        }
                        //  that.$refs.HuZhuIDCard[0].ImgList.push(_responseFile);
                       
                     }
                      //房产证打开弹层显示列表
                      if(BtnType=="2"){
                          let returnDataFileUrl = JSON.parse(_data.returnData).FilePL
                          if (returnDataFileUrl==null) {
                              that.$Notice.error({title: '提示', desc: "您没有产权证"});
                              return false;
                          }                          
                          console.log(returnDataFileUrl);
                          that.FormImage.FormData = returnDataFileUrl;
                          that.FileType=JSON.parse(_data.returnData).FileType;
                          that.FaChangZhengList=true;
                          clearInterval(that.timer);
                          that.timer = null;
                      }
                  })
            },
             //下载房产证
             UploadZhengZhaoOnly(h,params){
                let that = this;
                let paramsData =params.row
                let data ={
                    token:paramsData.token,
                    id:paramsData.id,
                    format:paramsData.format,
                    typeCode:that.FileType
                }
                
                that.InApi("api/WanShiTong/ShuiWuTong/UploadZhengZhaoOnly",data,"post").then(result => {
                    that.SpinShow=false;
                      if(!result) return false;
                      let _data = result;
                      if(_data.returnCode==false) {
                         that.$Notice.error({title: '提示', desc: _data.returnMessage});
                         return false;
                      }
                      if(_data.returnData==""){
                         that.$Notice.error({title: '提示', desc:"未获取到证照"});
                         return false;
                      }else{
                        let returnDataFileUrl = JSON.parse(_data.returnData).FileUrl;
                       console.log(returnDataFileUrl);
                       that.Visible=true;
                       that.ImgURL =  that.DomainApi+returnDataFileUrl[0];
                      }
                      
                })
            },
            SetImgData(){
                let _path = this.ImgURL.split("Resource");
                console.log(_path);
                let _responseFile ={
                    fileId: "Property",
                    fileName:"产权证",
                    path:"Resource"+_path[1]
                }
                if(this.currentPage=="yhfzxz_jm"){
                    this.$refs.WT_JSCQZ[0].ImgList.push(_responseFile);
                    this.$refs.WT_JSCQZ[0].ImgList["prop"]="WT_JSCQZ";
                    this.FormValidate.WT_JSCQZ.push(_responseFile)
                    this.FaChangZhengList=false;
                    this.Visible=false;
                }else{
                    this.$refs.Property[0].ImgList.push(_responseFile);
                    this.$refs.Property[0].ImgList["prop"]="Property";
                    this.FormValidate.Property.push(_responseFile)
                    this.FaChangZhengList=false;
                    this.Visible=false;
                }
                
            },
            clearTimer(type){
                let that = this;
                if(type==false){
                    console.log("false")
                    clearInterval(that.timer);
                    that.timer=null;
                }
            },
            ShangChuanXieYi(){
                let that = this;
                let jsonArr = {};
                let FlowXX={
                    S_FlowFlag:"申请审核",
                    S_NodeID: "lcfq",
                    S_RenWuID:that.S_AnJuanID,
                    WangTingOrLeaRun:""
                };
                let sendObj = Object.assign(FlowXX,jsonArr);
                //console.log(sendObj);
                that.SpinShow=true;
                that.InApi("api/Flow/flow/ShangChuanXieYi", sendObj, "post",).then(response => {
                    if(!response)return false;
                    that.SpinShow=false;
                    let _data = response;
                    if(_data.ReturnCode==false) {
                        that.$Notice.error({title:'提示',desc: _data.ReturnMessage});
                        return false;
                    }
                    let _ReturnMessage = (_data.ErrorMessage == "" || _data.ErrorMessage == null) ? "提交成功" : _data.ErrorMessage;
                    that.$Notice.success({title: '提示', desc: _ReturnMessage, duration: 0});
                    that.FormValidate.BtnName="生成申请单";
                    that.$refs.RoleForm.RoleDisabled=false;
                    that.$refs['FormValidate'].resetFields();
                    that.CurrentViewArr.forEach(function(item){
                        if(item.type=="file"){
                            let _prop=item.prop;
                            that.$refs[_prop][0].Reset();//清空图片
                        }
                    });
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .sendMsg{
        position: absolute;
        right:-10px;
        top:1px;
    }
    h3{
        font-size: 14px;
    }
    .ivu-row{
        margin-left: 16px!important;
        margin-right: 16px!important;
    }
    .txtClass h3{
        padding:10px 0
    }
    .contentArea .iconBlock{
        width:8px;
        height:20px;
        background:#f90;
        position: absolute;
        top:20px;
        left:0
    }
    .contentArea h3{
        text-align: left;
        font-size:18px;
    }
    .txtClass .iconBlock{
        width:8px;
        height:20px;
        background:#2EB4E9;
        position: absolute;
        top:10px;
        left:0
    }
    .submitBtn{
        padding-top:10px;
    }
    .formArea{
        padding-top:30px;
    }
    .ivu-form-item{
        text-align: left!important;
    }
    /*上传图片*/
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

    .explainTXT{
        text-align: left
    }
    .explainTXT p{
        line-height:32px;
    }
.contentDetail>li{
    height: 40px;
}
</style>
